import { useEffect, useRef, useState, type RefObject } from 'react';

export const useContainerWidth = (
  externalRef?: RefObject<HTMLDivElement | null>,
) => {
  const internalRef = useRef<HTMLDivElement | null>(null);
  const ref = externalRef ?? internalRef;
  const [width, setWidth] = useState<number | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });

    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return { ref, width };
};
